import { useParams } from '@tanstack/react-router'
import { useState } from 'react'
import { useCurrentRouteId, useCurrentUser } from '~/hooks'
import { captureException, captureFeedback, captureMessage, setTags } from '@sentry/react'
import { Footer, showDialog, Textarea } from '@bpinternal/ui-kit-next'

export const showBugReportDialog = ({
  error,
  onSubmit,
}: {
  error?: any
  onSubmit?: (props: { id: string; message: string }) => void
}) =>
  showDialog(({ close }) => <BugReportDialog close={close} error={error} onSubmit={onSubmit} />, {
    title: 'Report a bug',
  })

export const BugReportDialog = ({
  close,
  error,
  onSubmit,
}: {
  error?: any
  close: () => void
  onSubmit?: (props: { id: string; message: string }) => void
}) => {
  const [message, setMessage] = useState('')
  const params = useParams({ strict: false })
  const routeId = useCurrentRouteId()
  const { profilePicture: _, ...user } = useCurrentUser()

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-4">
        <Textarea
          className="h-24 grow"
          value={message}
          onChange={(e) => {
            setMessage(e.target.value)
          }}
          placeholder="Describe the bug you're experiencing..."
        />
      </div>

      <Footer
        disabled={!message}
        confirmLabel="Send"
        onConfirm={() => {
          const tags = { routeId, ...params }
          const currentUser = { email: user.email, id: user.id, username: user.displayName }

          setTags(tags)

          if (error) {
            const eventId = captureException(error, { tags: { ...tags, userMessage: message } })
            onSubmit?.({ id: eventId, message })
          } else {
            const eventId = captureMessage(message)
            captureFeedback(
              {
                message,
                associatedEventId: eventId,
                name: user.displayName,
                email: user.email,
                source: 'Bug report dialog',
              },
              { includeReplay: true, captureContext: { tags, user: currentUser } }
            )
          }
          close()
        }}
      />
    </div>
  )
}
